export { default } from './RelatedArticles';
